export * from './weak-map/from.js';
export * from './weak-map/is-weak-map.js';
export * from './weak-map/of.js';
